import { FormGroup, FormSection } from '@ksyos/design-system';
import { useMemo } from 'react';
import type { IService } from '@common/interfaces/';
import { getSelectedLanguage } from '@frontend/translate';
import { InputRadioGroup } from '../../../../elements/common';

export interface ISomnologyCanReferPatientWithoutSmartphoneProps {
    canReferPatientWithoutSmartphone: boolean;
    error?: string;
    onChange: (canReferPatientWithoutSmartphone: boolean) => void;
    onDoValidate?: () => void;
    service: IService;
}

export function SomnologyCanReferPatientWithoutSmartphone(props: ISomnologyCanReferPatientWithoutSmartphoneProps) {
    const language = useMemo(
        () => ({
            title: getSelectedLanguage().serviceOrganizationSetting.somnologyCanReferPatientWithoutSmartphone,
            yes: getSelectedLanguage().common.yes,
            no: getSelectedLanguage().common.no,
        }),
        []
    );

    return (
        <FormSection title={language.title}>
            <FormGroup
                hasErrors={Boolean(props.error)}
                label={language.title}
            >
                <InputRadioGroup
                    error={props.error}
                    labels={[language.yes, language.no]}
                    name="canReferPatientWithoutSmartphone"
                    onChange={(value) => props.onChange(value === language.yes)}
                    onDoValidate={async () => {
                        if (props.onDoValidate) {
                            props.onDoValidate();
                        }
                    }}
                    options={[language.yes, language.no]}
                    value={props.canReferPatientWithoutSmartphone ? language.yes : language.no}
                />
            </FormGroup>
        </FormSection>
    );
}
